/** Centralized user-facing tooltip copy used across the app. */
export const TOOLTIP_TEXTS = {
  account: {
    residentialAddress:
      "Add your residential address so that we know where to send any requested merchandise",
    marketingConsent:
      "If enabled, we will keep you up to date with the latest newsletters and streamer promotions via your email",
  },

  channelSync: {
    PENDING: {
      title: "Sync pending.",
      description:
        "No action needed. Please wait while the channel is being synced.",
    },
    INVALID: {
      title: "Sync failed.",
      description:
        "No streaming data is being collected for this channel. Action required: update the channel.",
    },
  },

  streamStats: {
    reach:
      "How many minutes of Pragmatic Play content my viewers have watched in the selected month",
    shareOfReach:
      "The % of all my viewer-minutes driven by Pragmatic Play content",
    airtime: "My total airtime on Pragmatic Play games in the selected month",
    shareOfAirtime:
      "How much I streamed Pragmatic Play games vs other content in the selected month",
    topReach:
      "My Pragmatic Play games that generated the most viewer-minutes on the selected month",
    averageViewers:
      "My top games by average concurrent viewers while streaming this game",
    topAirtime:
      "The Pragmatic Play games that I streamed the most of on the selected month",
    peakViewers:
      "My Pragmatic Play games with the highest concurrent viewer count during my streams",
  },

  targets: {
    airtime: "My total airtime on Pragmatic Play games in the selected month",
    shareOfAirtime:
      "How much I streamed Pragmatic Play games vs other content in the selected month",
  },
} as const
